export default {
  nav: {
    connect: "CONNECT",
    language: "Language"
  },
  about: {
    title: "ABOUT MINO",
    description: "MINO is a meme project initiated by a passionate community of Tetris lovers from Russia, in collaboration with Serbfund. More than just a nostalgic tribute to the legendary game, $MINO is a Web3 experiment in turning collective action into a shared, visual, and chain-based experience.",
    quote: "We believe that Tetris is more than a game — it's a cultural symbol, and a blueprint for how degen culture organizes chaos."
  },
  hero: {
    title: "Hi, I'm Mino!",
    subtitle: "I'm a quarter block of a tertromino.",
    buyButton: "BUY $MINO"
  },
  footer: {
    buy: "Buy $MINO",
    twitter: "X/Twitter",
    telegram: "Telegram",
    dexscreener: "DexScreener",
    contractAddress: "CA: ",
    copySuccess: "Contract address copied to clipboard!",
    copyError: "Failed to copy address"
  },
  features: {
    title: "Tetris",
    subtitle: "More than just a game",
    partnerships: {
      title: "Stacking is building",
      description: "Every transaction adds to a shared canvas. Every 4 transactions drop a Tetromino. Every line cleared burns tokens and tells a story."
    },
    community: {
      title: "Collaboration over competition",
      description: "Just like in Tetris, true progress comes when pieces fit together — when community actions synchronize toward a common goal."
    },
    ecosystem: {
      title: "From Russia, with rhythm",
      description: "We’re building a visual, cultural, and chain-native narrative — one block at a time."
    }
  }
}; 